var _rect, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCancelConsult(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.07,
    width: 100,
    height: 100,
    rx: 50,
    fill: "#003C71"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M75 35.175V30.175H38.475L43.475 35.175H75ZM80 67.675V42.675C80 41.3 78.875 40.175 77.5 40.175H62.5C61.125 40.175 60 41.3 60 42.675V51.7L65 56.7V45.175H75V62.675H70.975L78.3 70C79.275 69.675 80 68.775 80 67.675ZM25.15 23.95L21.625 27.475L26.175 32.025C25.45 32.875 25 33.975 25 35.175V62.675H20V70.175H64.325L70.2 76.05L73.725 72.525L25.15 23.95ZM30 62.675V35.85L56.825 62.675H30Z",
    fill: "#003C71"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCancelConsult);
export default __webpack_public_path__ + "static/media/cancel-consult.5c987ead3f9f48720a6d8dd80ef66b8a.svg";
export { ForwardRef as ReactComponent };